export const API_HOST = 'https://staging.chefami.com';
export const environment = {
  production: false,
  imagePath: '/assets/img/',
  recipeImagePath: `${API_HOST}/img/recipe/`,
  locationsImagePath: `${API_HOST}/img/locations/`,
  googleApiKey: 'AIzaSyDrF6KP4NQj3XttjIh7YetF_oEvP87pqWw',
  getSiteData: `${API_HOST}/api/fetch-site-data`,
  getAllGiftCards: `${API_HOST}/api/get-gift-cards`,
  validateGiftCard: `${API_HOST}/api/validate-gift-card`,
  applyGiftCardCoupon: `${API_HOST}/api/apply-coupon-gift-card`,
  purchaseGiftCard: `${API_HOST}/api/purchase-gift-card`,
  getGiftCardDetails: `${API_HOST}/api/gift-card-details`,
  cookieDomain: '.chefami.com',
  maintainence: `${API_HOST}/maintenance.php`,
};
